import * as React from 'react';
import { ITableSubfieldComponent } from '../types';
import { FormControl } from '@common/components/form-control';

import './text-field.styles.scss';

export type TextFieldProps = ITableSubfieldComponent<string> & {
  style?: React.CSSProperties;
  type?: 'text' | 'date';
};

export const TextField: React.FC<TextFieldProps> = ({ value, defaultValue, onChange, style, validate, type }) => {
  const [localValue, setLocalValue] = React.useState(value ?? defaultValue ?? '');

  React.useEffect(() => {
    if (localValue !== value) {
      setLocalValue(value ?? '');
    }
  }, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (validate && !validate(e.target.value)) {
      return;
    }

    setLocalValue(e.target.value);
  }, [validate]);

  const handleBlur = React.useCallback(() => {
    onChange(localValue);
  }, [localValue, onChange]);

  return (
    <FormControl
      className="DatasheetsResultDatasheetTableFieldRowTextField"
      style={style}
      type={type}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};